import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Message from 'components/Message';
import { TooltipContent, TooltipToggle } from 'components/Tooltip';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import { messages } from '../Services.messages';

const { element } = bem('services-list-item');

const ServicesListItemMetadata = ({ duration, equipmentLength, isDisabled, name, practitionersLength }) => (
  <>
    <div className={element('name')}>
      <Message
        message={messages.list.itemNameDuration}
        values={{
          duration,
          serviceName: name,
          grey: text => <span className={element('grey-text')}>{text}</span>,
        }}
      />
      <When predicate={isDisabled}>
        <TooltipToggle name="service-disabled-tooltip">
          <Isvg src={ICONS.infoYellow} />
        </TooltipToggle>
        <TooltipContent name="service-disabled-tooltip">
          <Message message={messages.list.disabledTooltip} />
        </TooltipContent>
      </When>
    </div>
    <When predicate={!!practitionersLength}>
      <Message
        as="div"
        className="text--ui70"
        message={messages.list.practitionersCount}
        values={{ practitionersCount: practitionersLength }}
      />
    </When>
    <When predicate={!!equipmentLength}>
      <Message
        as="div"
        className="text--ui70"
        message={messages.list.equipmentCount}
        values={{ equipmentCount: equipmentLength }}
      />
    </When>
  </>
);

ServicesListItemMetadata.propTypes = {
  duration: PropTypes.string,
  equipmentLength: PropTypes.number,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  practitionersLength: PropTypes.number,
};

export default ServicesListItemMetadata;
